import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { scoresQueries } from 'entities/scoring/model/userScore.query';

import type { IStateUserScore, IUserScoreResponseDto } from '../types';

const initialState: IStateUserScore = {
  score: 0,
  source: null,
  scoredUserData: '',
};

export const userScoreSlice = createSlice({
  name: 'userScore',
  initialState,
  reducers: {
    setScore: (state, { payload }: PayloadAction<number>) => {
      state.score = payload;
    },
    setUserScoreData: (state, { payload }: PayloadAction<IUserScoreResponseDto>) => {
      state.score = payload.score;
      state.source = payload.source;
      state.isLoading = false;
      state.scoredUserData = '';
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(scoresQueries.endpoints.getScores.matchPending, (state) => {
      state.isLoading = true;
    });
    builder.addMatcher(scoresQueries.endpoints.getScores.matchFulfilled, (state, { payload }) => {
      state.score = payload.score;
      state.source = payload.source;
      state.scoredUserData = payload.scoredUserData;

      state.isLoading = false;
    });
  },
});

export const { setScore, setUserScoreData } = userScoreSlice.actions;
